const MEDIA_PREFIX = "/media/";
const SAFE_OBJECT_SEGMENT = /^[A-Za-z0-9][A-Za-z0-9._-]{0,254}$/u;

/** Mirrors the server-side CMS public object-key policy for browser rendering. */
export function isSafePublicMediaUrl(value: unknown): value is string {
  if (typeof value !== "string" || value.length > MEDIA_PREFIX.length + 511 || !value.startsWith(MEDIA_PREFIX)) {
    return false;
  }
  const objectName = value.slice(MEDIA_PREFIX.length);
  if (!objectName || objectName.length > 511 || objectName.includes("..") || objectName.includes("\\")) return false;
  const segments = objectName.split("/");
  return segments.length <= 4 && segments.every((segment) =>
    segment !== "." && segment !== ".." && SAFE_OBJECT_SEGMENT.test(segment)
  );
}
